import axios from 'axios';
import querystring from 'querystring';

const urlString = '/quotes';

export default {

    fetch (filters = {}) {
        return axios.get(urlString + '?' + querystring.stringify(filters)).then(response => {
            return response;
        });
    },

    read (id) {
        return axios.get(`${urlString}/${id}`).then(response => {
            return response;
        });
    },

    update (data) {
        return axios.put(`${urlString}/${data.id}`, data).then(response => {
            return response;
        });
    },

    delete (itemId) {
        return axios.delete(`${urlString}/${itemId}`).then(response => {
            return response;
        });
    },

    create (data) {
        return axios.post(`${urlString}`, data).then(response => {
            return response;
        });
    }

};
